export const borderosRoutes = {
    path: '/autorizadorfinanceiro/borderos',
    redirect: { name: 'Listagem_Borderos_Aguardando' },
    meta: {
        rules: ['BORDEROS-00'],
    },
    children: [
        {
            path: 'aguardando',
            name: 'Listagem_Borderos_Aguardando',
            component: () => import('../borderos/Borderos.vue'),
            meta: {
                rules: ['BORDEROS-00'],
            },
        },
        {
            path: 'aprovados',
            name: 'Listagem_Borderos_Aprovados',
            component: () => import('../borderos/Borderos.vue'),
            meta: {
                rules: ['BORDEROS-00'],
            },
        },
        {
            path: 'reprovados',
            name: 'Listagem_Borderos_Reprovados',
            component: () => import('../borderos/Borderos.vue'),
            meta: {
                rules: ['BORDEROS-00'],
            },
        },
        {
            path: ':borderoId',
            name: 'Detalhar_Bordero',
            component: () => import('./Detalhar.vue'),
            meta: {
                rules: ['BORDEROS-02'],
            },
        },
    ],
};
